// extracted by mini-css-extract-plugin
export default {"mainContainer":"TermsOfUse_mainContainer__cS54J","title":"TermsOfUse_title__8ZJx+"};